<div *ngIf="isAgent" class="navigation wrapper hide-for-medium-down" >
    <nav class="row agent-menu ">
        <ul>
            <li>
                <a href="/agent">{{'MENU_AGENT_TOP_HOME' | resource:'MenuAgent'}}</a>
            </li>
            <li>
                <a href="/agent/search">{{'MENU_AGENT_TOP_BOOKINGS' | resource:'MenuAgent'}}</a>
            </li>
            <li>
                <a href="/agent/products">{{'MENU_AGENT_TOP_PRODUCTS' | resource:'MenuAgent'}}</a>
            </li>
            <li>
                <a href="/agent/profile">{{'MENU_AGENT_TOP_PROFILE' | resource:'MenuAgent'}}</a>
            </li>
        </ul>
    </nav>
</div>
